import { MinzeElement, Reactive, EventListeners, Attrs } from 'minze'
import { MODALS } from '../../constants'
import { Locale } from '../../modules/locale'
import { AdditionalTypes } from '../../modules/additionalTypes'
import { Font } from '../../constants'
import MainModule from '../../modules/main'

Locale.getInstance().registerKeySet('fr', 'discoveryKind', {
  title: 'Vous aimez quoi?',
})

Locale.getInstance().registerKeySet('en', 'discoveryKind', {
  title: 'What do you like?',
})

export class LvcDiscoveryKind extends MinzeElement {
  private selectedCategories: string[] = []
  private additionalTypes: any[] = []

  reactive: Reactive = [['selected', '', true]]

  attrs: Attrs = [['data-preload-cultural-profile', false]]

  async onCategoryClick(e: Event): Promise<void> {
    const target = e.target as HTMLElement
    const chip = target.closest('.category-chip') as HTMLElement
    if (chip) {
      const value = chip.getAttribute('value')
      if (this.selectedCategories.includes(value as string)) {
        let idx = this.selectedCategories.indexOf(value as string)
        this.selectedCategories.splice(idx, 1)
      } else {
        this.selectedCategories.push(value as string)
      }
    }

    this.selected = encodeURIComponent(JSON.stringify(this.selectedCategories))
    this.rerender()
  }

  async preloadCategories() {
    if (!this.dataPreloadCulturalProfile) return
    const preferences =
      (await MainModule.getInstance().getAuth().getUserData())?.profile?.culturalProfile ?? {}
    Object.values(preferences).forEach(categories => {
      ;(categories as string[]).forEach(category => {
        this.selectedCategories?.push(category)
      })
    })
    this.selected = encodeURIComponent(JSON.stringify(this.selectedCategories))
    this.rerender()
  }

  async onReady(): Promise<void> {
    await this.preloadCategories()
    this.additionalTypes = await AdditionalTypes.getInstance().getAllInTree()
    this.rerender()
  }

  renderCategories = (categories: any[]) => {
    let renderedCategories = []
    for (let k in categories) {
      let category = categories[k]
      renderedCategories.push(
        `<lvc-chip
          theme="dark-borderless" 
          width="fit-content"
          size="small"
          value="${category.code}" 
          class="category-chip" ${
            this.selectedCategories.includes(category.code) ? 'selected=true' : 'selected=false'
          }
          enable-hover-animation="true"
        >
          ${category.label}
        </lvc-chip>`
      )
    }

    return `
      <lvc-box class="items-container" display="flex" flexDirection="column" alignItems="center" mb="40px">
        <lvc-charlie-ecoute-icon width="235" height="235"></lvc-charlie-ecoute-icon>
        <lvc-box display="flex" flexWrap="wrap" justifyContent="center" columnGap="8px" rowGap="8px">${renderedCategories.join('')}</lvc-box>
      </lvc-box>
    `
  }

  html = () => /* html */ `
    <h1 class="title">${Locale.getKey('discoveryKind.title')}</h1>
    ${this.renderCategories(this.additionalTypes as any[])}
  `

  css = () => `
    :host {
      max-width: 540px;
      width: 100%;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      font-size: 60px;
      font-weight: ${Font.weight.extraBold};
      line-height: 1;
      margin: 0 0 40px;
    }
    .items-container {
      position: relative;
    }
    lvc-charlie-ecoute-icon {
      position: absolute;
      right: 0;
      margin-right: -235px;
      top: 50%;
      margin-top: -117.5px;
    }
    @media screen and (max-width: 991px) {
      .title {
        font-size: 48px;
        margin-bottom: 0px;
      }
      lvc-charlie-ecoute-icon {
        margin: 0;
        position: static;
      }
      lvc-charlie-ecoute-icon::part(image) {
        width: 158px;
        height: 158px;
      }
    }
    @media screen and (max-width: 540px) {
      .title {
        font-size: 24px;
      }
    }
  `

  eventListeners: EventListeners = [
    ['.category-chip', 'click', this.onCategoryClick.bind(this)],
    [window, 'lvc:user_state_changed', this.preloadCategories.bind(this)],
  ]
}

export interface LvcDiscoveryKind {
  selected: string
}
